var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.666 7h2a.667.667 0 000-1.333h-2a.667.667 0 000 1.333zm8-6.667H2.333a2 2 0 00-2 2v6a2 2 0 002 2h9.333a2 2 0 002-2v-6a2 2 0 00-2-2zm.667 8a.666.666 0 01-.667.667H2.333a.667.667 0 01-.667-.667v-4h10.667v4zm0-5.333H1.666v-.667a.667.667 0 01.667-.666h9.333a.666.666 0 01.667.666V3z",
    fill: "#fff"
  })));
}
export default SvgWallet;